import React from 'react';
import TopPanel from "./toppanel.js";
import Notifications from "./profile/notifications.js";
import PaymentsList from "./payments/payments_table.js";

module.exports = React.createClass({

    //CONSTs
    ACCOUNT: 0,
    PERMISSIONS: 1,
    PASSWORD: 2,
    SUBSCRIPTION: 3,
    LANGS: 4,
    NOTIFICATIONS: 5,
    TEST: 6,
    //---------------------------

    success: function(reply) {
        //reply.data.time = new Date(parseInt(reply.data.time)).toISOString().replace('Z', '');
        var state = {data: reply.data, time: reply.data.time, accChanges: {}};
        //if (this.state.data == null && state.data.is_owner)
        //    state.selectedItem = this.SUBSCRIPTION;
        this.setState(state);
    },
    loadFromServer: function(id=null) {
        this.commandCounter++;
        HC_SendRequest("profile", null, this.success, null);
    },
    getInitialState: function() {
        this.commandCounter = 0;
        return {
            data: null,
            selectedItem: this.ACCOUNT,
            items: [],
            password_data: {current: '', new_password: ''},
            wrongPassword: null,
            language: window.HC_CURRENT_LANGUAGE,
            changes: {}
        }
    },
    componentWillMount: function() {
        this.mountState = true;
    },
    componentWillUnmount() {
        this.mountState = false;
        HC_UnsubscribeHammerEvent(this.refs.hc_profile, "swiperight");
        HC_UnsubscribeHammerEvent(this.refs.hc_profile_cont, "swiperight");
    },
    componentDidMount: function() {
        HC_RestoreNavPanel();
        HC_SelectNavItem("li-profile");
        this.loadFromServer();
        HC_SubscribeHammerEvent(this.refs.hc_profile, "swiperight", HC_ToggleNavPanel);

        HC_SubscribeHammerEvent(this.refs.hc_profile_cont, "swiperight", this.goBack);
    },
    handleOnSelected: function(e) {
        var itemId = parseInt($(e.target).closest(".hc-list-view-item").attr('data-key'));
        this.setState({selectedItem: itemId});
        if (HC_DeviceType() === HC_CONST.SCR_PHONE) {
            HC_SwitchRPanel();
        }
    },
    getItemName: function(o) {
        var s = "";
        if (o == this.ACCOUNT)
            s = HC_LANG.PRO_ACCOUNT;
        if (o == this.PERMISSIONS)
            s =  HC_LANG.PRO_PERMISSIONS;
        if (o == this.PASSWORD)
            s = HC_LANG.PRO_PASSWORD;
        if (o == this.SUBSCRIPTION)
            s = HC_LANG.PRO_SUBSCRIPTION;
        if (o == this.LANGS)
            s =  HC_LANG.PRO_LANGUAGE;
        if (o == this.NOTIFICATIONS)
            s = HC_LANG.PRO_NOTIFICATIONS;
        if (o == this.TEST)
            s = "TEST";
        return ( <span data-key={o}>{s}</span> );
    },
    getRightCaption:function(o) {
        var s;

        if (!this.state.data)
            return null;

        if (o == this.PERMISSIONS) {
            if (this.state.data.is_owner)
                s = HC_LANG.PRO_OWNER;
            else if (this.state.data.acc_admin)
                s = HC_LANG.PRO_ADMIN;
            else if (this.state.data.acc_admin)
                s = HC_LANG.PRO_USER;
        }
        if (o == this.SUBSCRIPTION && this.state.data.days_left)
            s = this.state.data.days_left + ' ' + HC_LANG.PRO_DAYS_LEFT;
        if (o == this.LANGS) {
            var flStyle = {backgroundImage: "url('public/images/" + window.HC_CURRENT_LANGUAGE + ".svg')", backgroundSize: 'cover', marginTop: "0.3rem"};
            s = (<div className="flag flag-selected" style={flStyle}></div>)
        }
        if (!s)
            return null;
        return (
            <span className="hc-f-l hc-f4" style={{float:'right'}}>{s}</span>
        );
    },
    getCardImage: function() {
        if (this.state.data.card_brand === 'visa')
            return '/public/images/icon_visa.svg';
        if (this.state.data.card_brand === 'master')
            return '/public/images/icon_ms.svg';
        return '/public/images/icon_card.svg';
    },
    onTimezoneChanged: function(o) {
        this.state.accChanges.timezone = o.target.value;
        this.setState({accChanges: this.state.accChanges});
    },

    cancelTimezoneChanges: function(o) {
        this.setState({accChanges: {}});
    },

    saveTimezoneChanges: function(o) {
        var data = {};
        if (typeof(this.state.accChanges.timezone) !== 'undefined') {
            data.tz_offset = -60 * this.state.accChanges.timezone;
        }
        HC_SendRequest('set_settings', data, o => {this.loadFromServer()});
    },
    goBack: function() {
        HC_RestoreRPanel();
    },
    deleteCard: function() {
      HC_Confirm(HC_LANG.CONFORM_DELETE_CARD, HC_LANG.PRO_DELETE_CARD_BUTTON).then(function(){
          HC_SendRequest("update_customer", {is_deleting: true});
      }.bind(this));
    },
    changePlan: function() {
        window.location = '/subscribe';
    },
    updateCard: function() {
        var showCheckout = function() {
            if (window.HC_CHECKOUT || !StripeCheckout)
                return;
            window.HC_CHECKOUT = StripeCheckout.configure({
                key: this.state.data.stripe_account_key,
                locale: 'auto',
                name: HC_LANG.PRO_HACCP_ACCOUNT,
                'panel-label': HC_LANG.PRO_UPDATE_CARD_DETAILS,
                label: HC_LANG.PRO_UPDATE_CARD_DETAILS,
                'allow-remember-me': false,
                email: this.state.data.login,
                token: function(token) {
                    HC_SendRequest("update_customer", token, this.success);
                }.bind(this),
                closed: function() {
                    window.HC_CHECKOUT = null;
                }
            });

            $(window).on('popstate', function() {
                window.HC_CHECKOUT.close();
            });

            window.HC_CHECKOUT.open({});
        }.bind(this);

        if (!window.HC_LOADED_STRIPE_JS) {
            window.HC_LOADED_STRIPE_JS = true;
            var s = document.createElement('script');
            s.src = "https://checkout.stripe.com/checkout.js";
            s.onload = showCheckout;
            s.onerror = function(){window.HC_LOADED_STRIPE_JS=false};
            document.body.appendChild(s);
        } else {
            showCheckout();
        }
    },
    successPasswordRequest: function(reply) {
        this.success(reply);
        HC_ShowMessage(HC_LANG.ADM_PASS_CHANGED);
    },
    errorChanging: function (code, errorString) {
        if (code == 403 && errorString.indexOf('WRONG_PASSWORD') >=0) {
            this.state.wrongPassword = true;
            HC_Validate();
        }
        else
            HC_SetError(code, errorString);
    },
    onChangePassClicked: function(e) {
        if (!HC_Validate()) {
            this.state.afterFailState = true;
            return;
        }
        var data = {
            current_password: this.state.password_data.current,
            new_password: this.state.password_data.new_password
        };
        HC_SendRequest('edit_profile', data, this.successPasswordRequest, this.errorChanging);
        this.setState({password_data: {current: '', new_password: ''}});
    },
    newUserPasswordChanged(o) {
        this.state.wrongPassword = false;
        HC_Validate(o.target, !this.state.afterFailState);
        this.state.password_data[o.target.getAttribute('data-key')] = o.target.value;
        this.setState({password_data: this.state.password_data});
    },
    onLangChanged: function(o) {
        window.HC_ChangeLanguage(o.target.value);
        this.forceUpdate();
    },
    ensureGlobalValidationFunctionsCreated: function (o) {
        if (window.HC_PROFILE_VALIDATION != this) {
            window.HC_PROFILE_VALIDATION = this;
            window.HC_ProfileValidation_CurrentPassword = function(str) {
                return (this.state.wrongPassword ? [false, HC_LANG.PRO_WRONG_CURRPASS] : [true, ""]);
            }.bind(this);

            window.HC_ProfileValidation_Passwords = function (str) {
                return ($('#hc-profile-pass1').val() === $('#hc-profile-pass2').val() ? [true, ""] : [false, HC_LANG.ADM_PASS_NOTMATCH])
            };
        }
    },
    timeChanged: function(o) {
        if (!isNaN(Date.parse(o.target.value)))
            this.setState({time: o.target.value});
    },
    submitTime: function(o) {
        document.TimeForm.time.value = Date.parse(document.TimeForm.temp_time.value);
        return true;
    },
    renderSubscription: function() {
        var dt, payments, paymentItems, p, p2, buttons, card, planName, i, nextPayment;
        dt = this.state.data;
        p = '10px'; // padding in table
        p2 = '15px'; // big padding in table

        planName = "Free plan";

/*
        planName = dt.plan ? dt.plan : "No plan";

        if (!dt.card_number) {
            card = (
                <td style={{paddingTop:p2, paddingBottom:p2}}>{HC_LANG.PRO_NO_CARD}</td>
            );
            if (dt.plan && !dt.is_trial) {
                // we can't add card if there's no plan
                buttons = (
                    <td style={{paddingRight:0, textAlign:'right', paddingTop:p2, paddingBottom:p2}}>
                        <button className="hc-button" onClick={this.updateCard}>{HC_LANG.PRO_ADD_CARD}</button>
                    </td>
                );
            } else {
                buttons = (<td></td>);
            }
        }
        else {
            card = (
                <td style={{paddingTop:p2, paddingBottom:p2}}>
                    <img src={this.getCardImage()} style={{width:'28px', height:'19px'}}/>
                    <span style={{marginLeft:"5px"}}>{dt.card_number}</span>
                </td>
            );
            buttons = (
                <td style={{paddingRight:0, textAlign:'right', paddingTop:p2, paddingBottom:p2}}>
                    <button className="hc-button" onClick={this.updateCard}>{HC_LANG.PRO_EDIT_CARD}</button>
                    <button className="hc-button-cancel hc-f-l" style={{fontSize:"1.125rem", marginLeft:'5px'}} onClick={this.deleteCard}>{HC_LANG.PRO_DELETE_CARD}</button>
                </td>
            );
        }

        if (dt.plan && !dt.is_trial) {
            nextPayment = (
                <div>
                    <span className="hc-f-l">{HC_LANG.PRO_NEXT_PAYMENT}</span>
                    <table className="table" style={{width:'100%', marginTop:'10px', marginBottom:'20px'}}>
                        <tbody>
                        <tr>
                            <td style={{paddingLeft:0, paddingTop:p, paddingBottom:p}}>
                                <i className="fa fa-history hc-fa-small" style={{marginRight:'5px', paddingTop:p, paddingBottom:p}}/>
                                <span style={{marginRight:"10px"}}>{planName}</span>
                            </td>
                            <td className="hc-f-l"  style={{paddingTop:p, paddingBottom:p}}>
                                {dt.waiting_payment ? HC_LANG.PRO_WAITING_PAYMENT : (HC_LANG.PRO_WILL_BE_PAID + " " + dt.next_payment)}
                            </td>
                            <td style={{textAlign:'right', paddingRight:0, paddingTop:p, paddingBottom:p}}>{dt.next_amount}</td>
                        </tr>
                        <tr><td/><td/><td/></tr>
                        </tbody>
                    </table>
                </div>
            );
        }

        if (!dt.is_trial && dt.payments && dt.payments.length > 0) {
            payments = (<PaymentsList data={dt.payments} /> );
        }
*/

        //                             <button className="hc-button" onClick={this.changePlan}>{HC_LANG.PRO_CHANGE_PLAN}</button>
        //                 <td className="hc-f-l" style={{paddingLeft:0, paddingTop:p2, paddingBottom:p2}}>{HC_LANG.PRO_PAYMENT_DETAILS}</td>
        return (
            <div className="hc-f4" style={{padding:"5%", paddingTop:0}}>
                <table className="table" style={{width:'100%', marginTop:0, marginBottom:'20px'}}>
                    <tbody>
                    <tr>
                        <td className="hc-f-l" style={{paddingLeft:0, paddingTop:p2, paddingBottom:p2, borderTop:0}}>{HC_LANG.PRO_CURRENT_PLAN}</td>
                        <td style={{padding:0, paddingTop:p2, paddingBottom:p2, borderTop:0}}>{planName}</td>
                        <td style={{paddingRight:0, textAlign:'right', paddingTop:p2, paddingBottom:p2, borderTop:0}}>
                            <button className="hc-button hc-button-off">{HC_LANG.PRO_CHANGE_PLAN}</button>
                        </td>
                    </tr>
                    <tr>
                        {card}
                        {buttons}
                    </tr>
                    <tr><td/><td/><td/></tr>
                    </tbody>
                </table>
                {nextPayment}
                {payments}
            </div>
        );
    },
    renderAccount: function() {
        var captionDivStyle = {display: "inline-block", marginRight:"3%", paddingTop:"0.2rem"};
        captionDivStyle.flex = captionDivStyle.WebkitFlex = "0 1 8rem";

        var labelStyle = {padding:"1% 2% 0%", display: "flex"};
        labelStyle.flexFlow = labelStyle.WebkitFlexFlow = "row wrap";

        var div60 = {display: "inline-block", width: "60%", paddingTop:"0.2rem"};
        div60.flex = div60.WebkitFlex = "1 1 150px";
        div60.maxWidth = "300px";


        var savePanel;
        if (HC_AccAdmin() && !$.isEmptyObject(this.state.accChanges)) {
            savePanel = (<div style={{margin:"auto", marginTop:'10px'}}>
                <button type='button' className='hc-button' onClick={this.saveTimezoneChanges}>Save</button>
                <label type='button' className='hc-dialog-cancel hc-f3' onClick={this.cancelTimezoneChanges}
                       style={{marginLeft:"1rem", verticalAlign:"sub"}}>{HC_LANG.DUE_CANCEL}</label>
            </div>);
        } else {
            savePanel = (<div></div>);
        }

        var timezone, empty;
        if (this.state.accChanges.timezone)
            timezone = this.state.accChanges.timezone;
        else {
            if (typeof(this.state.data.tz_offset) === 'undefined') {
                timezone = 'empty';
                empty = (<option value="empty"></option>);
            } else {
                timezone = parseInt(this.state.data.tz_offset) / (-60);
            }
        }


        var timeZoneControl;
        if (HC_AccAdmin()) {
            timeZoneControl = (<select className="form-control hc-f4" onChange={this.onTimezoneChanged} value={timezone} style={div60}>
                {empty}
                <option value="-12">UTC-12</option>
                <option value="-11">UTC-11</option>
                <option value="-10">UTC-10</option>
                <option value="-9">UTC-9</option>
                <option value="-8">UTC-8</option>
                <option value="-7">UTC-7</option>
                <option value="-6">UTC-6</option>
                <option value="-5">UTC-5</option>
                <option value="-4">UTC-4</option>
                <option value="-3">UTC-3</option>
                <option value="-2">UTC-2</option>
                <option value="-1">UTC-1</option>
                <option value="0">UTC</option>
                <option value="1">UTC+1</option>
                <option value="2">UTC+2</option>
                <option value="3">UTC+3</option>
                <option value="4">UTC+4</option>
                <option value="5">UTC+5</option>
                <option value="6">UTC+6</option>
                <option value="7">UTC+7</option>
                <option value="8">UTC+8</option>
                <option value="9">UTC+9</option>
                <option value="10">UTC+10</option>
                <option value="11">UTC+11</option>
                <option value="12">UTC+12</option>
            </select>)
        } else {
            var timezoneStr = '';
            if (typeof timezone === 'number') {
                timezoneStr = 'UTC';
                if (parseInt(timezone) > 0)
                    timezoneStr += '+' + timezone;
                else if (parseInt(timezone) < 0)
                    timezone += timezone;
            }
            timeZoneControl = (<span className="hc-f4" style={div60}>{timezoneStr}</span>);
        }

    var adminSettings = [
        (<div key="1" className="hc-flex-display" style={labelStyle}>
            <span className="hc-f4 hc-f-l" style={captionDivStyle}>{HC_LANG.PRO_TIMEZONE}</span>
            {timeZoneControl}
        </div>),
        (<div key="2" className="hc-flex-display" style={labelStyle}>{savePanel}</div>)
        ];










        return (
            <div className="container"
                 style={{top:"60px", bottom:0, width:"100%", overflowY:"auto", WebkitOverflowScrolling:'touch', overflowX:"hidden", marginTop:"2%"}}>

                <div className="hc-flex-display" style={labelStyle}>
                    <div style={captionDivStyle} className="hc-f4 hc-f-l">{HC_LANG.PRO_ACC}</div>
                    <label className="hc-f4" style={div60}>{this.state.data.account}</label>
                </div>
                <div className="hc-flex-display" style={labelStyle}>
                    <div style={captionDivStyle}
                         className="hc-f4 hc-f-l">{HC_LANG.PRO_EMAL_ADDRESS}</div>
                    <label className="hc-f4" style={div60}>{this.state.data.login}</label>
                </div>
                <div className="hc-flex-display" style={labelStyle}>
                    <div style={captionDivStyle} className="hc-f4 hc-f-l">{HC_LANG.CHL_NAME}</div>
                    <label className="hc-f4" style={div60}>{this.state.data.name}</label>
                </div>
                {adminSettings}
            </div>
        );
    },
    renderPermissions: function() {
        var captionDivStyle = {display: "inline-block", marginRight:"3%", paddingTop:"0.2rem"};
        captionDivStyle.flex = captionDivStyle.WebkitFlex = "0 1 8rem";
        var captionDivRightStyle = {display: "inline-block", marginRight:"1%", flex: "0 1 10rem", paddingTop:"0.2rem" };
        captionDivRightStyle.flex = captionDivRightStyle.WebkitFlex = "0 1 10rem";

        var labelStyle = {padding:"1% 2% 0%", display: "flex"};
        labelStyle.flexFlow = labelStyle.WebkitFlexFlow = "row wrap";

        var div60 = {display: "inline-block", width: "60%", paddingTop:"0.2rem"};
        div60.flex = div60.WebkitFlex = "1 1 150px";
        div60.maxWidth = "300px";

        var getRights = function (data) {
            var rights = [];
            if (data.acc_login)
                rights.push(HC_LANG.ADM_LOGIN);
            if (data.acc_reports)
                rights.push(HC_LANG.ADM_GEN_REP);
            if (data.acc_input)
                rights.push(HC_LANG.ADM_INP_DATA);
            if (data.acc_admin)
                rights.push(HC_LANG.ADM_CAN_ADM);
            var i = 0;
            var strings = rights.map(function(s) {return (<div key={i++}>{s}</div>);});
            return <div>{strings}</div>;
        };
        div60.maxWidth = "250px";

        return (
            <div class="container"
                 style={{top:"60px", bottom:0, width:"100%", overflowY:"auto", WebkitOverflowScrolling:'touch', overflowX:"hidden", marginTop:"2%"}}>
                <div className="hc-flex-display" style={labelStyle}>
                    <div style={captionDivStyle} className="hc-f4 hc-f-l">{HC_LANG.PRO_U_RIGHTS}</div>
                    <label className="hc-f4" style={div60}>
                        {getRights(this.state.data)}
                    </label>
                </div>
            </div>
        );
    },
    renderPasswords: function() {

        var captionDivRightStyle = {display: "inline-block", marginRight:"1%", flex: "0 1 10rem", paddingTop:"0.2rem" };
        captionDivRightStyle.flex = captionDivRightStyle.WebkitFlex = "0 1 10rem";

        var labelStyle = {padding:"1% 2% 0%", display: "flex"};
        labelStyle.flexFlow = labelStyle.WebkitFlexFlow = "row wrap";

        var div100Right = {display: "inline-block", width: "60%", maxWidth: "300px", marginBottom:"0"};
        div100Right.flex = div100Right.WebkitFlex = "1 1 200px";

        return (
            <div className="container" style={{top:"60px", bottom:0, width:"100%", overflowY:"auto", WebkitOverflowScrolling:'touch', overflowX:"hidden", marginTop:"2%"}}>
                <div className="hc-flex-display" style={labelStyle}>
                    <div style={captionDivRightStyle} className="hc-f4 hc-f-l">{HC_LANG.PRO_CURPASS}</div>
                    <div style={div100Right}>
                        <input data-key="current" className="form-control hc-validated" type="password"
                               value={this.state.password_data.current} onChange={this.newUserPasswordChanged}
                               data-vfunc="HC_ProfileValidation_CurrentPassword" data-vtext="hc-profile-curpass-error"
                               autoComplete="off"/>
                        <div id="hc-profile-curpass-error" style={{display:'none'}}></div>
                    </div>
                </div>
                <div className="hc-flex-display" style={labelStyle}>
                    <div style={captionDivRightStyle} className="hc-f4 hc-f-l">{HC_LANG.PRO_NEW_PASS}</div>
                    <div style={div100Right}>
                        <input id="hc-profile-pass1" data-key="new_password" className="form-control hc-validated"
                               type="password" value={this.state.password_data.new_password} onChange={this.newUserPasswordChanged}
                               data-vfunc="HC_ValidatePassword" data-vtext="hc-profile-pass-error"
                               autoComplete="off"/>
                        <div id="hc-profile-pass-error" style={{display:'none'}}></div>
                    </div>
                </div>
                <div className="hc-flex-display" style={labelStyle}>
                    <div style={captionDivRightStyle} className="hc-f4 hc-f-l">{HC_LANG.PRO_CONF_PASS}</div>
                    <div style={div100Right}>
                        <input id="hc-profile-pass2" data-key="conf_password" className="form-control hc-validated"
                               type="password" value={this.state.password_data.conf_password} onChange={this.newUserPasswordChanged}
                               data-vfunc="HC_ProfileValidation_Passwords" data-vtext="hc-profile-pass2-error"
                               autoComplete="off"/>
                        <div id="hc-profile-pass2-error" style={{display:'none'}}></div>
                    </div>
                </div>
                <div className="hc-flex-display" style={labelStyle}>
                    <div style={captionDivRightStyle} className="hc-f4 hc-f-l"> </div>
                    <div style={div100Right}>
                        <button className="hc-button" onClick={this.onChangePassClicked}
                                style={{marginTop:"1rem", marginBottom:"1rem"}}>{HC_LANG.PRO_CHANGE}</button>
                    </div>
                </div>
            </div>);
    },
    renderLanguages: function() {
        var captionDivRightStyle = {display: "inline-block", marginRight:"1%", flex: "0 1 10rem", paddingTop:"0.2rem" };
        captionDivRightStyle.flex = captionDivRightStyle.WebkitFlex = "0 1 10rem";

        var labelStyle = {padding:"1% 2% 0%", display: "flex"};
        labelStyle.flexFlow = labelStyle.WebkitFlexFlow = "row wrap";

        var div100Right = {display: "inline-block", width: "60%", maxWidth: "300px", marginBottom:"0"};
        div100Right.flex = div100Right.WebkitFlex = "1 1 200px";

        // language
        var languages = [['en', 'English' ], ['ge', 'Deutsch'], ['du', "Nederlands"], ['sp','Español'], ['it','Italiano'], ['fr','Français'], ['ch','中文'], ['tu','Türkçe'], ['ru', 'Русский']];
        var i = 0;
        var languagesItem = languages.map(function (lang) {
            return (
                <option key={i++} value={lang[0]}>{lang[1]}</option>);
        }.bind(this));

        return (
            <div className="container"
                 style={{top:"60px", bottom:0, width:"100%", overflowY:"auto", WebkitOverflowScrolling:'touch', overflowX:"hidden", marginTop:"2%"}}>
                <div className="hc-flex-display" style={labelStyle}>
                    <div style={captionDivRightStyle} className="hc-f4 hc-f-l">{HC_LANG.PRO_LANGUAGE}</div>
                    <div style={div100Right}>
                        <select className="form-control hc-f4" data-key="language" onChange={this.onLangChanged} value={window.HC_CURRENT_LANGUAGE} >
                            {languagesItem}
                        </select>
                    </div>
                </div>
            </div>
        );
    },
    renderTest: function() {
        return (
            <div style={{padding:"20px"}}>
                <p className="hc-f-l"><b>Test mode! </b>
                    You can set any time on server and see how subscription will react.
                    This time setting affects all accounts.
                    Time is constant and can be changed only with this setting.
                    Wait ~5 seconds after changing time and refresh the page.
                </p>
                <p>Current time: <span>{this.state.data.time}</span></p>
                <form name="TimeForm" action="/time" method="POST" onSubmit={this.submitTime} style={{padding:"20px"}}>
                    Set new UTC time
                    <input type="datetime-local" name="temp_time" value={this.state.time} onChange={this.timeChanged}/>
                    <input type="hidden" name="time"/>
                    <input type="submit" value="Submit"/>
                </form>
                <p style={{marginTop:'30px'}}>
                    MasterCard test card:<br/>
                    5555555555554444
                    <br/><br/>
                    Visa test card:<br/>
                    4242424242424242
                    <br/><br/>
                    Attaching this card will succeed, but attempts to charge will fail:<br/>
                    4000000000000341
                </p>
            </div>
        );
    },
    render: function() {
        this.ensureGlobalValidationFunctionsCreated();

        var dt, content, itemsTypes, items, i, licon, liconAction;

        dt = this.state.data;

        if (HC_DeviceType() === HC_CONST.SCR_PHONE) {
            licon = 'fa-angle-left';
            liconAction = this.goBack;
        }

        i = 0;
        itemsTypes = [this.ACCOUNT, this.PERMISSIONS, this.PASSWORD, this.LANGS, this.NOTIFICATIONS/*, this.SUBSCRIPTION*/];
        // if (dt && dt.is_owner) {
        //     itemsTypes.push(this.SUBSCRIPTION);
        //     if (dt.account.toLowerCase().indexOf("debug") === 0)
        //         itemsTypes.push(this.TEST);
        // }
        items = itemsTypes.map(function(o){
            var itemClass = "hc-list-view-item hc-f3";
            if (o === this.state.selectedItem)
                itemClass += " hc-active-item";
            return (
                <div data-key={o} key={++i} className={itemClass} style={{padding: "20px", height:"70px", cursor:"pointer"}} onClick={this.handleOnSelected}>
                    {this.getItemName(o)}
                    {this.getRightCaption(o)}
                </div>
            );
        }.bind(this));

        //TODO: refactor!!!!! split to many React classes
        if (dt) {
            switch (this.state.selectedItem) {
                case this.ACCOUNT:
                    content = this.renderAccount();
                    break;
                case this.PERMISSIONS:
                    content = this.renderPermissions();
                    break;
                case this.PASSWORD:
                    content = this.renderPasswords();
                    break;
                case this.SUBSCRIPTION:
                    content = this.renderSubscription();
                    break;
                case this.LANGS:
                    content = this.renderLanguages();
                    break;
                case this.NOTIFICATIONS:
                    content = (<Notifications pushOn={dt.push_on} emailOn={dt.email_on} showOnly={dt.show_only} onSuccess={this.success}/>);
                    break;
                case this.TEST:
                    content = this.renderTest();
                    break;
            }
        }

        return (
            <div style={{height:"100%"}}>
                <div ref="hc_profile" className="hc-list-panel hc-br">
                    <TopPanel text={HC_LANG.PRO_CAPTION} licon="fa-bars" onLiconClick={HC_ToggleNavPanel}/>
                    <div className="hc-list-view" style={{overflowY: "auto", WebkitOverflowScrolling:'touch', bottom: 0, width:"100%"}}>
                        {items}
                    </div>
                </div>
                <div ref="hc_profile_cont" className="hc-content-panel">
                    <TopPanel text={this.getItemName(this.state.selectedItem)} licon={licon} onLiconClick={liconAction}/>
                    {content}
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./profile.js